import { render, staticRenderFns } from "./Senders.vue?vue&type=template&id=308e83d6&"
import script from "./Senders.vue?vue&type=script&lang=ts&"
export * from "./Senders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports